import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
/* empty css          */
const ResponseTreeView = ({
  data,
  initiallyExpandedDepth = 1
}) => {
  if (data !== null && typeof data === "object" && !Array.isArray(data)) {
    const entries = Object.entries(data);
    return /* @__PURE__ */ jsx("div", { className: "graphiql-response-tree", children: entries.map(([k, v]) => /* @__PURE__ */ jsx(TreeNode, { name: k, value: v, depth: 0, initiallyExpandedDepth }, k)) });
  }
  return /* @__PURE__ */ jsx("div", { className: "graphiql-response-tree", children: /* @__PURE__ */ jsx(RootValue, { value: data, initiallyExpandedDepth }) });
};
const RootValue = ({
  value,
  initiallyExpandedDepth
}) => {
  const expandable = value !== null && typeof value === "object";
  const [open, setOpen] = useState(initiallyExpandedDepth > 0);
  if (!expandable) {
    const valueClass = `graphiql-tree-value graphiql-tree-${scalarClass(value)}`;
    return /* @__PURE__ */ jsx("div", { className: "graphiql-tree-row", style: {
      paddingLeft: 0
    }, children: /* @__PURE__ */ jsx("span", { className: valueClass, children: formatScalar(value) }) });
  }
  const isArr = Array.isArray(value);
  const entries = isArr ? value.map((v, i) => [String(i), v]) : Object.entries(value);
  const count = entries.length;
  const summary = isArr ? `Array [${count}]` : `Object {${count}}`;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "graphiql-tree-row", style: {
      paddingLeft: 0
    }, children: [
      /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-tree-toggle", "aria-label": open ? "Collapse" : "Expand", "aria-expanded": open, onClick: () => setOpen((o) => !o), children: open ? "▾" : "▸" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-summary", children: summary })
    ] }),
    open && /* @__PURE__ */ jsx("div", { children: entries.map(([k, v_0]) => /* @__PURE__ */ jsx(TreeNode, { name: k, value: v_0, depth: 1, initiallyExpandedDepth }, k)) })
  ] });
};
const TreeNode = ({
  name,
  value,
  depth,
  initiallyExpandedDepth
}) => {
  const expandable = value !== null && typeof value === "object";
  const [open, setOpen] = useState(depth < initiallyExpandedDepth);
  if (!expandable) {
    const valueClass = `graphiql-tree-value graphiql-tree-${scalarClass(value)}`;
    return /* @__PURE__ */ jsxs("div", { className: "graphiql-tree-row", style: {
      paddingLeft: depth * 16
    }, children: [
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-key", children: name }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-colon", children: ":" }),
      /* @__PURE__ */ jsx("span", { className: valueClass, children: formatScalar(value) })
    ] });
  }
  const isArr = Array.isArray(value);
  const entries = isArr ? value.map((v, i) => [String(i), v]) : Object.entries(value);
  const count = entries.length;
  const summary = isArr ? `Array [${count}]` : `Object {${count}}`;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "graphiql-tree-row", style: {
      paddingLeft: depth * 16
    }, children: [
      /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-tree-toggle", "aria-label": open ? "Collapse" : "Expand", "aria-expanded": open, onClick: () => setOpen((o) => !o), children: open ? "▾" : "▸" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-key", children: name }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-colon", children: ":" }),
      /* @__PURE__ */ jsx("span", { className: "graphiql-tree-summary", children: summary })
    ] }),
    open && /* @__PURE__ */ jsx("div", { children: entries.map(([k, v_0]) => /* @__PURE__ */ jsx(TreeNode, { name: k, value: v_0, depth: depth + 1, initiallyExpandedDepth }, k)) })
  ] });
};
function scalarClass(v) {
  if (typeof v === "string") {
    return "string";
  }
  if (typeof v === "number") {
    return "number";
  }
  if (typeof v === "boolean") {
    return "bool";
  }
  return "null";
}
function formatScalar(v) {
  if (typeof v === "string") {
    return JSON.stringify(v);
  }
  if (v === null) {
    return "null";
  }
  return String(v);
}
export {
  ResponseTreeView
};
//# sourceMappingURL=index.js.map
